import { useMutation } from 'react-query';

import { createUserGroup as mutationFn } from 'api/endPoints/createUserGroup';

export const useMutationCreateUserGroup = () => {
    return useMutation<
        unknown,
        QueryError,
        {
            group_name: string;
            roles_list: number[];
            projects_list: number[];
            customer_id: number;
            newName?: string;
        }
    >((params) => mutationFn(params));
};
